import React from "react";
import "../css/Home.css";
import settings from "../svgs/settings.svg";
import scalable from "../svgs/scalable.svg";
import security from "../svgs/security.svg";
import appImage from "../svgs/imageLogo.svg";
import midImage from "../assests/mid-image.svg";
import Button from "../components/Button";
import AppDescMob from "../components/AppDescMob";
import pencil from '../svgs/pencil.svg';

import Lottie from 'react-lottie';
import BigBubble from "../bubbles/big_buble (1).json";
import SmallBubble from "../bubbles/Small_buble.json"
import Partners from "../components/Partners";

const Home = ({props}) => {  



  const handleLearnMore = () => (
    window.location = "https://menafn.com/1105323643/One-Stop-Platform-Of-CEX-And-DEX-LOVELY-SWAP"
  )

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: SmallBubble,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };  

  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: BigBubble,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };  


  return (
    <>
      <div className="main-Container">
        <div className="BubbleAnimTop">
          <Lottie
            options={defaultOptions}
            height={400}
            width={400}
          />
        </div>
        <div className="BubbleAnimBottom">
          <Lottie
            options={defaultOptions}
            height={400}
            width={400}
          />
        </div>
        
        <div className="card-main-container">
          <div className="top-main-content">
            <strong>Zero Fee DEX</strong>
            <p>
              <span className="by">by</span>
              <span className="lvl">LOVELY</span>
              <span className="swp">FINANCE</span>
            </p>
          </div>
          <div className="mid-images">
            <img src={midImage} alt="midImage" className="midImage" />
          </div>

          <div className="bottom-buttons">
            <Button value="Launch App" className="gtstarted" onClick={()=> window.location = "https://lovelyswap.com"}/>
            <Button value="Documentation" className="whitepaper documents-btn" onClick={()=> window.location = "https://doc.lovelyswap.com"}/>
          </div>
        </div>
      </div>

      <div className="milestones">
        <div className="milestones-innerDiv">
          <p>upcoming Milestones</p>
          <div className="flex">
            <div className="div-milestones-info">
              <Button value="01" className="milestones-btn" />

              <div className="main-svg-div">
                <span>Lovely Launchpad</span>
                <p>
                  The independent ILO Platform. Helpful for new projects &
                  startups.
                </p>
              </div>
            </div>

            <div className="div-milestones-info">
              <Button value="02" className="milestones-btn" />
              <div className="main-svg-div">
                <span>P2P</span>
                <p>
                  The convenient crypto-to-fiat exchange - the first ever
                  implemented on DEX platforms.
                </p>
              </div>
            </div>

            <div className="div-milestones-info long">
              <Button value="03" className="milestones-btn" />
              <div className="main-svg-div">
                <span>Limit Order Trading</span>
                <p>
                  The Limit Order allows you to set the rate you want to
                  exchange your currency for another. If that rate becomes
                  available, the exchange will occur automatically. With the
                  Limit Order in place, you won't need to monitor the market -
                  you can sit back and wait for the trade to happen.
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>

        <Partners/>

        {
          props ? <AppDescMob onClick = {handleLearnMore}/>: 
           <div className="app-description-main-container">
          <div className="inner-app-container">
            <div className="left-app-container">
              <span>
                What is
                <br /> Lovely Swap?
              </span>

              <p className="p-top">
                LOVELY SWAP is a key stage in the process of the Decentralized
                finance (DeFi) infrastructure developing and updating. As DeFi
                evolves, more and more projects integrate with decentralized
                alternatives to traditional financial institutions, in
                particular, Decentralized Exchange (DEX).
              </p>
              <p className="p-mid">
                LOVELY SWAP is a highly modified version of Uniswap (the largest
                DEX operating on the Ethereum blockchain), which has been
                adapted to unlock and handle various important financial
                capabilities.
              </p>

              <Button value="learn more" className="gtstarted" onClick={handleLearnMore}/>
            </div>
            <div className="right-app-container">
            <div className="BubbleAnimTopRightContainer">
          <Lottie
            options={defaultOptions2}
            height={400}    
            width={400}
          />
        </div>
        <div className="BubbleAnimTopRightContainer2">
          <Lottie
            options={defaultOptions2}
            height={400}    
            width={400}
          />
        </div>  
              <div className="flex-end-left-container">
                <div className="background-container">
                  <img src={settings} alt="security-setting" />
                  <span>Automation</span>
                </div>

                <div className="background-container">
                  <img src={security} alt="error-security" />
                  <span>Security</span>
                </div>
              </div>

              <div className="flex-end-right-container">
                <div className="background-container">
                  <img src={appImage} alt="error-app" />
                  <span>Zero fee dex</span>
                </div>

                <div className="background-container">
                  <img src={scalable} alt="security-scalable" />
                  <span>SCALABILITY</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        }

        

        

     
      <div className="Inquiry-container">
        <div className="inquiry-inner">
          <button className="inquiry-btn btn"><img src={pencil} alt="error-pencil"/></button>
          <div className="inquiry-svg-div">
            <div>
              <span>Inquiry</span>
              <p>info@lovelyswap.com</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
